<style lang="less">
    .ugo-hide-label{
    
    }
    </style>
    <template>
      <FormItem :label="label"  :class="{'ugo-hide-label':true}">
          <BaseFlexTablePro
            style="border:1px solid var(--border);"
            :columns="computedCols"
            v-model="items"
            @input="handleSave"
            :model="db"
            :design="design"
            :summary="config?.summary"
            :hideTool="true"
            />
    </FormItem>
    
    </template>
    
    <script>
    import UgoMark from './Mark.vue';
    import render from './render.js';
    import defaultValueMixin from '../mixins/default-value';
    import composedMixin from '../mixins/composed';
    import {cloneDeep} from 'lodash';
    export default {
      mixins: [defaultValueMixin, composedMixin],
      cname: '数据表',
      icon: 'biaoge',
      corder: 92,
      components: {UgoMark},
      initModel(e) {
        e.config = {
          cols: [{
            name: '第一列',
            control: 'UgoInput',
            key: 'col1',
            width: '10%',
            align:'center',
            config:{
                simple:true,
                options:[]
            }
          }, {
            name: '第二列',
            control: 'UgoRadio',
            key: 'col2',
            width: 100,
            align:'center',
            config:{
                simple:true,
                options:[]
            }
          }],
        };
      },
      properties: [{
        label: '编辑列',
        key: 'cols',
        control: 'ZZLColumnDesign',
      }],
      data() {
        return {
          items: cloneDeep(this.value),
        };
      },
      computed:{
        computedCols(){
          return this.config?.cols.map((v)=>{
            return {
              name: v.name,
              key: v.key,
              width: v.width,
              align: v.align,
              control: v.control,
            };
          });
        }
      },
      props: ['config', 'value', 'editable', 'label', 'required', 'db','design'],
      watch: {
        value: {
          handler(v) {
            console.log('wtach-table:', v);
            if (v) {
              this.items = cloneDeep(this.value);
            }
          },
          deep: true,
          immediate: true,
        },
      },
      methods: {
        handleSave() {
          this.$emit('input', this.items);
        },
      },
    };
    </script>
    
    <style lang="less">
    .ugo-table{
      .ivu-table-cell{
        height:100%;
        width:100%;
        position: relative;
        padding:0;
        display: flex;
        align-items: center;
        justify-content: center;
        .ivu-input-wrapper{
          height:100%;
        }
        .ivu-input{
          width:100%;
          height:100%;
          border:none;
          background:none;
          margin:0;
          border-radius: 0;
          padding:0 10px;
        }
      }
    
    
    }
    
    .control-wrapper{
      background:#fff;
      width:100%;
      height:100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .control-wrapper-selected{
      background:#ffd;
    }
    
    .control-wrapper-disabled{
      background:rgb(255, 254, 254);
    
    }
    </style>
    